import { orderBy } from 'lodash';

const formatYear = ({ rawDate }: { rawDate: string }) => {
  const date = new Date(rawDate);
  const year = date.getUTCFullYear();

  return String(year);
};

interface PublicationDateCheckboxProps {
  value: string;
  count?: number | string;
  selected?: boolean;
  label?: string;
}

export const reduceCheckboxDefault = ({
  list = [],
  labels = {},
}: {
  list?: PublicationDateCheckboxProps[];
  labels?: any;
}) =>
  list.map((item) => ({
    ...item,
    label: labels[item.value] || item?.label || item?.value || '++NO_VALUE++',
  }));

export const reducePublicationDateCheckbox = ({
  list,
}: {
  list: PublicationDateCheckboxProps[];
}) => {
  const options = list.reduce((prev: any, curr: PublicationDateCheckboxProps) => {
    const dateParsed = formatYear({ rawDate: curr.value });
    const prevDate = prev.find((value: any) => value?.label === dateParsed);

    return prevDate
      ? [
          ...prev.filter((value: any) => value?.label !== dateParsed),
          {
            ...prevDate,
            value: [...prevDate.value, curr.value],
            count: prevDate.count + Number(curr.count),
            selected: Boolean(prevDate.selected + curr.selected),
          },
        ]
      : [...prev, { ...curr, value: [curr.value], label: dateParsed, count: Number(curr.count) }];
  }, []);

  // Making sure it's ordered by Label.
  return orderBy(options, ['label'], ['desc']);
};

interface PublicationDateChipProps {
  key: string;
  value: string;
}

export const reduceChipDefault = ({
  list = [],
  labels = {},
}: {
  list?: PublicationDateChipProps[];
  labels?: any;
}) => list.map((item) => ({ ...item, label: labels[item.value] || item?.value || '++NO_VALUE++' }));

export const reducePublicationDateChip = ({ list }: { list: PublicationDateChipProps[] }) => {
  const options = list.reduce((prev: any, curr: PublicationDateChipProps) => {
    const dateParsed = formatYear({ rawDate: curr.value });
    const prevDate = prev.find((value: any) => value?.label === dateParsed);

    return prevDate
      ? [
          ...prev.filter((value: any) => value?.label !== dateParsed),
          {
            ...prevDate,
            value: [...prevDate.value, curr.value],
          },
        ]
      : [...prev, { key: curr.key, value: [curr.value], label: dateParsed }];
  }, []);

  return options;
};
